import React from 'react';
import Button from '../ui/Button';
import heroImage from '../../assets/landing-hero.png';

const HeroSection: React.FC = () => {
  const sectionStyle: React.CSSProperties = {
    padding: '8rem 0 6rem 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '78vh',
    position: 'relative',
    overflow: 'hidden',
    backgroundImage: `linear-gradient(90deg, rgba(10,10,10,0.94) 0%, rgba(10,10,10,0.78) 42%, rgba(10,10,10,0.22) 100%), url(${heroImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center right',
    borderBottom: '1px solid var(--border-color)',
  };

  const contentContainerStyle: React.CSSProperties = {
    maxWidth: '720px',
    position: 'relative',
    zIndex: 1,
  };

  const titleStyle: React.CSSProperties = {
    marginBottom: '2rem',
  };

  const descriptionStyle: React.CSSProperties = {
    fontSize: '1.25rem',
    maxWidth: '600px',
    marginBottom: '3rem',
  };

  const buttonGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'wrap',
  };

  return (
    <section style={sectionStyle}>
      <div className="container">
        <div style={contentContainerStyle}>
          <span className="mono-label">AI business-data analytics</span>
          
          <h1 style={titleStyle}>
            GabMic
          </h1>
          
          <p style={descriptionStyle}>
            Upload CSV or Excel business data, review the detected columns, and get clear metrics, charts, summaries, and answers that adapt to the file you provided.
          </p>
          
          <div style={buttonGroupStyle}>
            <a href="/signup">
              <Button variant="primary" size="lg">
                Create Account
              </Button>
            </a>
            <a href="/signin">
              <Button variant="outline" size="lg">
                Sign In
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
